import React from 'react';
import { HeaderButton } from './HeaderButton';

interface HintButtonProps {
  ariaLabel: string;
  onClick?: () => void;
}

export const HintButton: React.FC<HintButtonProps> = props => {
  return (
    <HeaderButton {...props}>
      <svg
        width="12"
        height="17"
        viewBox="0 0 12 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.620311 5.32754C0.620311 6.08754 1.28031 6.46754 1.94031 6.46754C2.56031 6.46754 3.18031 6.12754 3.26031 5.42754C3.36031 3.92754 4.24031 3.22754 6.04031 3.22754C7.64031 3.22754 8.50031 4.18754 8.50031 5.22754C8.50031 5.38754 8.48031 5.54754 8.44031 5.70754C8.08031 7.78754 4.84031 7.86754 4.84031 11.7275C4.84031 12.5275 5.44031 12.9275 6.04031 12.9275C6.64031 12.9275 7.24031 12.5275 7.24031 11.7075C7.24031 9.26754 10.8203 9.32754 11.2003 5.76754C11.2403 5.52754 11.2603 5.28754 11.2603 5.04754C11.2603 2.84754 9.58031 0.787538 6.02031 0.787538C2.60031 0.787538 0.760311 2.60754 0.620311 5.22754V5.32754ZM6.06031 16.9675C6.90031 16.9675 7.56031 16.2675 7.56031 15.3875C7.56031 14.5075 6.90031 13.7875 6.06031 13.7875C5.22031 13.7875 4.58031 14.5075 4.58031 15.3875C4.58031 16.2675 5.22031 16.9675 6.06031 16.9675Z"
          fill="#897A66"
        />
      </svg>
    </HeaderButton>
  );
};
